import React, { useEffect, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { Typography } from '@mui/material';

const RichTextEditor = (props) => {

  const { value, onChange } = props
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  useEffect(() => {
    if (value === '') {
      setEditorState(EditorState.createEmpty());
      return;
    }

    const contentBlock = htmlToDraft(value || '');
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks,
        contentBlock.entityMap
      );
      const newEditorState = EditorState.createWithContent(contentState);

      const currentContent = editorState.getCurrentContent().getPlainText().trim();
      const newContent = newEditorState.getCurrentContent().getPlainText().trim();

      if (currentContent !== newContent) {
        setEditorState(newEditorState);
      }
    }
  }, [value]);

  const handleEditorChange = (state) => {
    setEditorState(state);
    const html = draftToHtml(convertToRaw(state.getCurrentContent()));
    onChange(html);
  };

  return (
    <div>
      <Editor editorState={editorState} onEditorStateChange={handleEditorChange} wrapperStyle={{ border: '1px solid #ccc', borderRadius: '4px', marginBottom: 4 }} editorStyle={{ padding: '10px', minHeight: '150px' }}
        toolbar={{
          options: ['inline', 'blockType', 'fontFamily', 'list', 'textAlign', 'history'],
          inline: { options: ['bold', 'italic', 'underline', 'strikethrough'] },
          list: { options: ['unordered', 'ordered'] },
          textAlign: { options: ['left', 'center', 'right'] },
        }}
      />
      {/* {error && (
        <Typography color="error" variant="caption">
          {error.message}
        </Typography>
      )} */}
    </div>
  );
};


export default RichTextEditor;
